export const GET_LOCALSTORAGE_AUTH = 'get_localstorage_auth';
export const SET_LOCALSTORAGE_AUTH = 'set_localstorage_auth';
export const REMOVE_LOCALSTORAGE_AUTH = 'remove_localstorage_auth';

export const GET_USER = 'get_user';
export const LIST_USER = 'list_user';

export const GET_WORKER = 'get_worker';
export const LIST_WORKER = 'list_worker';

export const LIST_ATTENDANCE = 'list_attendance';

export const LOGIN_USER_SUCCESS = 'login_user_success';
export const LOGIN_USER_FAILURE = 'login_user_failure';

export const LOGOUT_USER_SUCCESS = 'logout_user_success';
export const LOGOUT_USER_FAILURE = 'logout_user_failure';

export const GET_ORGANIZATION = 'get_organization';
export const LIST_ORGANIZATION = 'list_organization';

export const GET_GATEWAY = 'get_gateway';
export const LIST_GATEWAY = 'list_application';

export const GET_APPLICATION = 'get_application';
export const LIST_APPLICATION = 'list_application';

export const GET_REPEATER = 'get_repeater';
export const LIST_REPEATER = 'list_repeater';

export const GET_COMMUNICATOR = 'get_communicator';
export const LIST_COMMUNICATOR = 'list_communicator';
export const LIST_AVAILABLE_COMMUNICATOR = 'list_available_communicator';

export const GET_DETECTOR = 'get_detector';
export const LIST_DETECTOR = 'list_detector';

export const LIST_DETECTOR_EVENT = 'list_detector_event';

export const LIST_WORKER_LANGUAGE = 'list_worker_language';

export const GET_MESSAGE = 'get_message';
export const LIST_MESSAGE = 'list_message';

export const GET_MESSAGE_MACROS = 'message_macros/get';
export const GET_MESSAGE_MACROS_SUCCESS = 'message_macros/get/success';
export const GET_MESSAGE_MACROS_FAILURE = 'message_macros/get/failure';
export const GET_MESSAGE_MACRO = 'message_macro/get';
export const GET_MESSAGE_MACRO_SUCCESS = 'message_macro/get/success';
export const GET_MESSAGE_MACRO_FAILURE = 'message_macro/get/failure';
export const SUBMIT_MESSAGE_MACRO = 'message_macro/submit';
export const SUBMIT_MESSAGE_MACRO_SUCCESS = 'message_macro/submit/success';
export const SUBMIT_MESSAGE_MACRO_FAILURE = 'message_macro/submit/failure';
export const UPDATE_MESSAGE_MACRO = 'message_macro/update';
export const UPDATE_MESSAGE_MACRO_SUCCESS = 'message_macro/update/success';
export const UPDATE_MESSAGE_MACRO_FAILURE = 'message_macro/update/failure';
export const DELETE_MESSAGE_MACRO = 'message_macro/delete';
export const DELETE_MESSAGE_MACRO_SUCCESS = 'message_macro/delete/success';
export const DELETE_MESSAGE_MACRO_FAILURE = 'message_macro/delete/failure';

export const MESSAGE_MACRO_SUCCESS = 'message_macro/success';
export const MESSAGE_MACRO_FAILURE = 'message_macro/failure';

export const GET_NOTICE = 'get_notice';
export const LIST_NOTICE = 'list_notice';

export const GET_NOTICE_MACRO = 'get_notice_macro';
export const LIST_NOTICE_MACRO = 'list_notice_macro';

export const LIST_EVENT = 'list_event';
export const LIST_EVENT_ALERT = 'list_event_alert';

// Dashboard
export const LIST_COOPERATION = 'list_cooperation';
export const LIST_SITE = 'list_site';
